<template>
  <RouterLink
    v-if="!!to"
    :to="to"
    :class="classes"
    :target="target || ''"
  >
    <slot />
  </RouterLink>
  <button
    v-else
    :class="classes"
    @click.prevent="$emit('click')"
  >
    <slot />
  </button>
</template>
<script>
import classes from '@/utils/classes'

export default {
  name: 'Button',
  props: {
    wide: Boolean,
    tall: Boolean,
    to: String,
    target: String,
    className: String,
    size: {
      type: String,
      default: 'large',
    },
  },
  computed: {
    classes() {
      const {
        $style, wide, size, className,
      } = this
      return classes(
        $style.button,
        wide && $style.wide,
        $style[size],
        // tall && $style.tall,
        className && className,
      )
    },
  },
}
</script>
<style lang="scss" module>
  @import './Button.scss';
</style>
